import soapService from "../soapService/soapService";
import moment from 'moment/moment';

const MA_ISOH_LIMIT = 500;

/**
 * @typedef {Object} MaIsohService
 * @function getClientVersion
 * @function getUserInfo
 * @function loadCarDimensions
 * @function changePassword
 */
export default angular.module('maIsohService', [
	soapService
]).service('maIsoh', function ($soap, $log, $q) {
	this.url = 'http://project-ma-isoh/public/service/v5';
	this.WSDLUrl = 'http://project-ma-isoh/public/service/wsdl/v5';

	// this.url = 'http://10.93.0.19/project-ma-isoh/public/service/v5';
	// this.WSDLUrl = 'http://10.93.0.19/project-ma-isoh/public/service/wsdl/v5';
	
	this.setAPIUrl = (url, WSDLUrl) => {
		this.url = url;
		this.WSDLUrl = WSDLUrl;
		$soap.setWSDLUrl(WSDLUrl);
	};
	
	this.setUser = (user) => {
		this.user = new User(user.login, user.password);
	};

	
	/**
	 * Messages
	 */
	
	this.getClientVersion = () => {
		return $soap.post(this.url, GetFreeClientVersionMsg.NAME);
	};
	
	this.getUserInfo = (login) => {
		$log.debug('UzivatelView', arguments);
		return $soap.post(this.url, UzivatelViewMsg.NAME, new UzivatelViewMsg(this.user, login));
	};
	
	this.getFacilityInfo = (ic, zuj, provoz) => {
		$log.debug('GetFacilityInfo', arguments);
		return $soap.post(this.url, ZarizeniViewMsg.NAME, new ZarizeniViewMsg(this.user, ic, zuj, provoz));
	};
	
	this.getFacilityList = () => {
		return $soap.post(this.url, ZarizeniListMsg.NAME, new ZarizeniListMsg(this.user));
	};
	
	this.testApi = () => {
		$log.debug('AppInfo', arguments);
		let res;
		try {
			res = $soap.post(this.url, 'AppInfo', new AppInfoMsg(this.user));
		} catch (e) {
		}
		
		return res;
	};
	
	this.changePassword = (login, oldPassword, newPassword) => {
		$log.debug('UzivatelHesloZmena', arguments);
		return $soap.post(this.url, UzivatelHesloZmenaMsg.NAME, new UzivatelHesloZmenaMsg(this.user, login, oldPassword, newPassword));
	};
	
	this.loadCarDimensions = (from) => {
		$log.debug('CiselnikZnacek', arguments);
		return $soap.post(this.url, CiselnikZnacekMsg.NAME, new CiselnikZnacekMsg(this.user, from));
	};
	
	this.loadCarPartsDimensions = (from) => {
		$log.debug('CiselnikCasti', arguments);
		return $soap.post(this.url, CiselnikCastiMsg.NAME, new CiselnikCastiMsg(this.user, from));
	};
	
	this.loadCarsWithPage = (ic, zuj, provoz, ident, page = 0) => {
		if (page > 0) page = page * MA_ISOH_LIMIT; //limit in MA ISOH, hardcoded in their API
		
		return $soap.post(this.url, AutovrakListMsg.NAME, new AutovrakListMsg(this.user, ic, zuj, provoz, ident, page));
	};
	
	this.loadAllCars = (ic, zuj, provoz, ident, page = 0, allCars = [], parentResolve = false) => {
		return new Promise((resolve, reject) => {
			this.loadCarsWithPage(ic, zuj, provoz, ident, page).then((result) => {
				let cars = result.json.autovraky.item;
				
				//no cars in MA ISOH
				if (angular.isUndefined(cars)) {
					cars = [];
				}

				// for first car it returns only object, so convert it to array
				if (!angular.isArray(cars)) {
					cars = [cars];
				}

				allCars.push(...cars);

				//are there more cars in MA ISOH?
				if (cars.length === MA_ISOH_LIMIT) {
					page++;
					this.loadAllCars(ic, zuj, provoz, ident, page, allCars, parentResolve);
				} else {
					if (parentResolve) {
						parentResolve(allCars);
					} else {
						resolve(allCars);
					}
				}
			});
		});
	};

	this.loadCars = (ic, zuj, provoz, ident) => {
		$log.debug('AutovrakList', arguments);
		
		let deferred = $q.defer();
		
		this.loadAllCars(ic, zuj, provoz, ident, 0, [], deferred.resolve);
		
		return deferred.promise;
	};

	this.loadCar = (ic, zuj, provoz, cisloDokladu, registracniZnacka, vin, predalIc, predalDatumNarozeni) => {
		$log.debug('AutovrakRefresh', arguments);
		return $soap.post(this.url, AutovrakRefreshMsg.NAME, new AutovrakRefreshMsg(this.user, ic, zuj, provoz, cisloDokladu, registracniZnacka, vin, predalIc, predalDatumNarozeni));
	};

	this.sendCar = (car, userSettings, osobaPrijala) => {
		$log.debug('AutovrakInsert', arguments);
		return $soap.post(this.url, AutovrakInsertMsg.NAME, new AutovrakInsertMsg(this.user, car, userSettings, osobaPrijala));
	};

	this.sendPhotos = (uid, type, photo) => {
		$log.debug('AutovrakPhotoUpload', arguments);
		return $soap.post(this.url, AutovrakFotoUploadMsg.NAME, new AutovrakFotoUploadMsg(this.user, uid, type, photo));
	};

	this.stornoCar = (uid) => {
		return $soap.post(this.url, AutovrakStornoMsg.NAME, new AutovrakStornoMsg(this.user, uid));
	};

	this.updateHmotnost = (uid) => {
		return $soap.post(this.url, HmotnostTPUpdateMsg.NAME, new HmotnostTPUpdateMsg(this.user, uid));
	}

	this.loadAppMessages = () => {
		$log.debug('AppMessages', arguments);
		return $soap.post(this.url, AppMessagesMsg.NAME, new AppMessagesMsg(this.user, this.version));
	}
}).name;

/**
 * User object for SOAP API
 */
class User {
	constructor(login, password) {
		this.login = login;
		this.password = password;
	}
}

/**
 * Base class for protected messages - messages with username and password
 */
class ProtectedMsg {
	/**
	 * @param {User} user - User object
	 */
	constructor(user) {
		this.jmeno = user.login;
		this.heslo = user.password;
	}
	
	/**
	 * @return {string}
	 */
	static get NAME() {
		return this.name.replace('Msg', '');
	}
}

class GetFreeClientVersionMsg {

}

class AppInfoMsg extends ProtectedMsg {
	constructor(user) {
		super(user);
		this.NAME = 'AppInfo';
	}
}

class UzivatelViewMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param {string} username - viewed user
	 */
	constructor(user, username) {
		super(user);
		
		this.input = {
			username: username
		};
	}
}

class UzivatelHesloZmenaMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param {string} username
	 * @param {string} stareHeslo
	 * @param {string} noveHeslo
	 */
	constructor(user, username, stareHeslo, noveHeslo) {
		super(user);
		
		this.input = {
			username: username,
			stareHeslo: stareHeslo,
			noveHeslo: noveHeslo
		};
	}
}

class CiselnikZnacekMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param {string} odDatum - DD.MM.YYYY from when you want to download dimensions
	 */
	constructor(user, odDatum = '1.1.1970') {
		super(user);
		
		this.input = {
			odDatum: odDatum
		};
	}
}

class CiselnikCastiMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param {string} odDatum - DD.MM.YYYY from when you want to download dimensions
	 */
	constructor(user, odDatum = '1.1.1970') {
		super(user);
		
		this.input = {
			odDatum: odDatum
		};
	}
}

class AutovrakListMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param {int} ic
	 * @param {int} zuj
	 * @param {int} provoz ID of place
	 * @param {int} ident - Got from ZarizeniViewMsg
	 * @param {int} page - how much cars to skip
	 */
	constructor(user, ic, zuj, provoz, ident, page) {
		super(user);
		
		this.input = {
			ic: ic,
			zuj: zuj,
			provoz: provoz,
			after: page,
			limit: MA_ISOH_LIMIT,
			ident: ident
		};
	}
}

class AutovrakInsertMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param car
	 * @param userSettings
	 * @param osobaPrijala
	 */
	constructor(user, car, userSettings, osobaPrijala) {
		super(user);
		
		this.input = angular.copy(car);
		
		this.input.ic = userSettings.workplace.ic;
		this.input.zuj = userSettings.workplace.zuj;
		this.input.provoz = userSettings.workplace.provoz;
		this.input.souhlasCJ = userSettings.agreement.cislo;
		this.input.souhlasKraj = userSettings.agreement.krajsky_urad;
		this.input.osobaPrijala = osobaPrijala;
		
		//date conversion to format for MA ISOH
		let date = new Date(userSettings.agreement.datum_vydani);
		this.input.souhlasOd = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
		
		date = new Date(userSettings.agreement.datum_souhlasu);
		this.input.souhlasDo = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
		
		//convert date of car person
		if (angular.isDefined(this.input.predalDatumNarozeni)) {
			let date = moment(this.input.predalDatumNarozeni, 'DD.MM.YYYY');
			this.input.predalDatumNarozeni = date.format('DD.MM.YYYY'); //date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
		}
		
		/**
		 * Ignore bad format of VIN
		 * @type {number}
		 */
		this.input.forced407 = 1;
		this.input.forced405 = 1;
		
		delete this.input.weightType;
		delete this.input.weightTypeValue;
	}
}

class ZarizeniViewMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param {string} ic
	 * @param {string} zuj
	 * @param {string} provoz
	 */
	constructor(user, ic, zuj, provoz) {
		super(user);
		
		this.input = {
			ic: ic,
			zuj: zuj,
			provoz: provoz
		};
	}
}

export class AutovrakFotoUploadMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param {string} uid
	 * @param {string} cislo
	 * @param {string} fotografie
	 */
	constructor(user, uid, cislo, fotografie) {
		super(user);
		
		this.input = {
			uid: uid,
			cisloFotografie: cislo,
			fotografie: fotografie
		};
	}
	
	/**
	 * From MA ISOH docs
	 * @type {number}
	 */
	static get PHOTO_VIN() {
		return 1;
	}
	
	/**
	 * From MA ISOH docs
	 * @type {number}
	 */
	static get PHOTO_INSIDE() {
		return 2;
	}
	
	/**
	 * From MA ISOH docs
	 * @type {number}
	 */
	static get PHOTO_OUTSIDE() {
		return 3;
	}
}

class AutovrakRefreshMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param ic
	 * @param zuj
	 * @param provoz
	 * @param cisloDokladu
	 * @param registracniZnacka
	 * @param vin
	 * @param predalIc
	 * @param predalDatumNarozeni
	 */
	constructor(user, ic, zuj, provoz, cisloDokladu, registracniZnacka, vin, predalIc, predalDatumNarozeni) {
		super(user);

		if(angular.isUndefined(registracniZnacka)) registracniZnacka = '';
		if(angular.isUndefined(predalIc)) predalIc = '';
		if(angular.isUndefined(predalDatumNarozeni)) predalDatumNarozeni = '';

		this.input = {
			ic: ic,
			zuj: zuj,
			provoz: provoz,
			cisloDokladu: cisloDokladu,
			registracniZnacka: registracniZnacka,
			vin: vin,
			predalIc: predalIc,
			predalDatumNarozeni: predalDatumNarozeni
		};
	}
}

class ZarizeniListMsg extends ProtectedMsg {
	constructor(user) {
		super(user);
	}
}

class AutovrakStornoMsg extends ProtectedMsg {
	/**
	 *
	 * @param {User} user
	 * @param uid
	 */
	constructor(user, uid) {
		super(user);
		
		this.input = {
			UID: uid
		};
	}
}

class HmotnostTPUpdateMsg extends ProtectedMsg {
	constructor(user, uid) {
		super(user);
		
		this.input = {
			uid: uid,
			hmotnostDleTP: 4.000
		};
	}
}

/**
 *
 * @param {User} user
 * @param version
 */
class AppMessagesMsg extends ProtectedMsg {
	constructor(user, version) {
		super(user);

		this.input = {
			version: version
		};
	}
}

export class ZarizeniInsertUpdateMsg extends ProtectedMsg {
	/**
	 *
	 * @param user
	 * @param zarizeni
	 */
	constructor(user, zarizeni) {
		super(user);
		
		this.input = {
			ico: zarizeni.Ico,
			icz: zarizeni.Icz,
			nazev: zarizeni.Nazev,
			ulice: zarizeni.Ulice,
			obec: zarizeni.Obec,
			psc: zarizeni.Psc,
			zuj: zarizeni.Zuj,
			povolenoOd: zarizeni.PovolenoOd,
			povolenoDo: zarizeni.PovolenoDo,
			souvisejiciZarizeni: zarizeni.SouvisejiciZarizeni
		}
	}
}

export class ZarizeniUpdateAdresaMsg extends ProtectedMsg {
	/**
	 *
	 * @param user
	 * @param zarizeni
	 */
	constructor(user, zarizeni) {
		super(user);
		
		this.input = {
			icz: zarizeni.Icz,
			ulice: zarizeni.Ulice,
			obec: zarizeni.Obec,
			psc: zarizeni.Psc,
			zuj: zarizeni.Zuj
		};
	}
}

export class GetIcoNewMsg extends ProtectedMsg {
	constructor(user) {
		super(user);
	}
}

export class GetIcoAllMsg extends ProtectedMsg {
	constructor(user) {
		super(user);
	}
}

export class FirmaUpdateMsg extends ProtectedMsg {
	constructor(user, firma) {
		super(user);
		
		this.input = {
			ico: firma.Ico,
			nazev: firma.Nazev,
			ulice: firma.Ulice,
			obec: firma.Obec,
			psc: firma.Psc,
			zuj: firma.Zuj,
			iszrDatum: firma.IszrDatum,
			iszrAdresa: firma.IszrAdresa
		};
	}
}



// WEBPACK FOOTER //
// build/services/maIsohService/maIsohService.js